import React,{useState,useEffect,useRef,useCallback} from 'react';
// comps
import InfoPart from '../comps/infoPart'
import UserOptions from '../comps/useroptions'
import FriendPart from '../comps/friendPart'
import MainBody from '../comps/mainBody'
import ToolPart from '../comps/toolPart'
import Catline, { parseCatline, catlineKey } from '../comps/catline'
import {useSelector,useDispatch} from 'react-redux'
import {Helmet} from "react-helmet";
// bad imports make no sense delete
import * as actions from '../data/posts_data'
// all kind of data
import * as action2 from '../data/history_data'
import * as action from '../store/actions'
import * as authAction from '../store/authAction'
import {useNavigate,useParams} from 'react-router-dom';
import Logou from '../img/n89.png';
 import { BiSearch} from 'react-icons/bi';
import { HiOutlineUserGroup } from 'react-icons/hi';
import '../styles/home.css';
// end of bad import

const Main = props => {
  // bring data without refresh
    const params = useParams();
    const {category} = params || {};
  const navigate = useNavigate();
  const[isload,SetLoad] = useState(true);
  const [error,setError] = useState('');
  const [iscategory,setCategory] = useState(() => parseCatline(category))
  //bad
  const dispatch = useDispatch();
//   useEffect(()=>{
//
// },[dispatch])
const[isType,setType] = useState('l');
const feedRef = useRef(null);
const logoRef = useRef(null);
const logoSlotRef = useRef(null);
const lastScroll = useRef(0);
const hiddenPx = useRef(0);
const pageRef = useRef(5);
const loadingMore = useRef(false);
const categoryRef = useRef(iscategory);
const feedReq = useRef(0);
categoryRef.current = iscategory;
const selectedKey = catlineKey(iscategory);
const [page,setpage] = useState(5);

useEffect(()=>{
  const userData = localStorage.getItem('userdata');
  if (!userData) return;
  try {
    const {id, pid} = JSON.parse(userData);
    dispatch(authAction.auth(id, pid));
  } catch (err) {}
},[dispatch])

useEffect(()=>{
  let cancelled = false;
  const req = ++feedReq.current;
  const still = () => !cancelled && feedReq.current === req;
  const loadFeed = async () => {
    SetLoad(true);
    setError('');
    const first = selectedKey ? 12 : 5;
    pageRef.current = first;
    setpage(first);
    try {
      await dispatch(actions.get_posts(0, first, selectedKey, still));
    } catch (err) {
      if (still()) setError(err.message);
    }
    if (still()) SetLoad(false);
    if (still() && feedRef.current) feedRef.current.scrollTop = 0;
  };
  loadFeed();
  return () => { cancelled = true; };
},[dispatch, selectedKey])

  const getData2 = useCallback(async () => {
    if (loadingMore.current) return
    loadingMore.current = true
    try {
      const req = feedReq.current
      const added = await dispatch(actions.get_postss(pageRef.current, 8, catlineKey(categoryRef.current), () => feedReq.current === req))
      pageRef.current += 8
      setpage(pageRef.current)
      return added || { longs: 0, shorts: 0 }
    } catch (err) {
      setError(err.message)
      return { longs: 0, shorts: 0 }
    } finally {
      loadingMore.current = false
    }
  }, [dispatch])

  const onHomeScroll = (event) => {
    const el = event.currentTarget;
    const logo = logoRef.current;
    const slot = logoSlotRef.current;
    if (logo && slot) {
      const height = logo.offsetHeight + 22;
      const delta = el.scrollTop - lastScroll.current;
      lastScroll.current = el.scrollTop;
      let next = hiddenPx.current + delta;
      if (el.scrollTop < 4) next = 0;
      next = Math.max(0, Math.min(height, next));
      hiddenPx.current = next;
      slot.style.height = `${Math.max(0, height - next)}px`;
      logo.style.transform = `translateY(${-next}px)`;
    }
  };

// end data without refesh
const list = useSelector(state => state.PostReducer.followLong);
const shortsList = useSelector(state => state.PostReducer.followShort);

let listt;

// console.log(list2,list,listt)

  return(
  <section className="WatchPage homeFeed">
    <Helmet>
    <title>Watch new things ,videos and people</title>
  <meta name="description" content='here you can watch best short and long video '/>
<meta name='keywords' content='watch,pinweelo website,watch page'/>
 <link rel="canonical" href={`https://pinweelo.com/watch/${category}`} />
 <meta name="theme-color" content="#000000" />
    <meta name="apple-mobile-web-app-status-bar-style" content="#000000" />
    </Helmet>
    <FriendPart Watch={true} />
    <div className="homeFeedScroll" ref={feedRef} onScroll={onHomeScroll}>
    <div className="homeStickyStack">
    <div className="homeLogoSlot" ref={logoSlotRef}>
<div className='main-header' ref={logoRef}>
    <div>
<img src={Logou} />
<h1>Pinweelo</h1>
</div>
<div className="mainHeaderActions">
<button
  type="button"
  className="search-icon-button"
  aria-label="Search"
  onClick={() => navigate('/search')}
>
  <BiSearch />
</button>
<button
  type="button"
  className="search-icon-button"
  aria-label="Rooms"
  onClick={() => navigate('/rooms')}
>
  <HiOutlineUserGroup />
</button>
</div>
</div>
    </div>
<Catline iscategory={iscategory} setCategory={setCategory} />
    </div>

<MainBody key={selectedKey || 'all'} page={page} fetchData={getData2} embedded isload={isload} error={error} list={list || []} shortsList={shortsList} type={'l'} isWatch={true} emptyTitle={selectedKey ? `No ${parseCatline(iscategory).join(' + ')} videos yet` : undefined} />
    </div>


  </section>
  )
}
export default Main;
